import Vue from 'vue';
import VueNumber from 'vue-number-animation';

Vue.use(VueNumber, {});
